// extracted by mini-css-extract-plugin
export var centerAligned = "y9POtR6wUu4C5JPCFx9f";
export var info = "HqC9yGoCMCnwpGxZoGos";
export var leftBorder = "WczfvjJ4FseJaAnsuLmT";
export var negative = "VNZQGawFIJ8N5gtDiw_b";
export var neutral = "ZejIeTuR_QCMQVA1TJjw";
export var positive = "YYvnjkrL3Gb4mW2vLndQ";
export var primary = "LAwJfjyIENUhN7KaiVOG";
export var root = "pWziy0nMmzb7hBQKpago";
export var secondary = "_sPdmfDO3lktPQ4ePYdg";
export var title = "hRP2kT3NuBkfwHOfXybJ";
export var warning = "rD8ToA0pGd7RtzSCo9Q2";
export var withChevron = "limLvUlXC7HATyASsqpu";